<ng-template #content>
  @if (node) {
    <div class="modal-header">
      <h5 class="modal-title">
        <i class="fa fa-lock me-2"></i>
        Permissions —
        <span class="clearance-node-name">{{ node.name }}</span>
      </h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
    </div>

    <div class="modal-body">

      @if (alertInfo.show) {
        <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false" class="mb-3">
          {{ alertInfo.message }}
        </ngb-alert>
      }

      @if (isLoading) {
        <loader [config]="{ overlay: false, size: 'sm', text: 'Loading profiles…' }"></loader>
      }

      @if (!isLoading && profiles.length > 0) {
        <div class="clearance-toolbar">
          <p class="clearance-hint">
            Profiles with a checked box can see this
            {{ node.type === 'file' ? 'file' : 'folder' }}.
            Changes are saved immediately.
          </p>
          <div class="clearance-bulk-actions">
            <button
              type="button"
              class="btn btn-sm btn-outline-primary"
              [disabled]="!canSelectAll"
              (click)="selectAll()">
              <i class="fa fa-check-square-o me-1"></i>Select All
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary"
              [disabled]="!canDeselectAll"
              (click)="deselectAll()">
              <i class="fa fa-square-o me-1"></i>Deselect All
            </button>
          </div>
        </div>
        <div class="clearance-list">
          @for (profile of profiles; track profile.code) {
            <div class="clearance-row">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [id]="'clr-' + profile.code"
                  [checked]="profile.enabled"
                  [disabled]="profile.loading || isBulkSaving || isAlwaysEnabled(profile)"
                  (change)="onToggle(profile, $event)"
                />
                <label class="form-check-label" [for]="'clr-' + profile.code">
                  <span class="clearance-code-badge">{{ profile.code }}</span>
                  <span class="clearance-label">{{ profile.label }}</span>
                  @if (isAlwaysEnabled(profile)) {
                    <span class="clearance-always-badge">always</span>
                  }
                </label>
              </div>
              @if (profile.loading) {
                <div class="spinner-border spinner-border-sm clearance-spinner" role="status">
                  <span class="visually-hidden">Saving…</span>
                </div>
              }
            </div>
          }
        </div>
      }

    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="close()">
        Close
      </button>
    </div>
  }
</ng-template>
